'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { id: 'nav_dashboard', label: 'Dashboard', href: '/dashboard' },
    { id: 'nav_books', label: 'Book List', href: '/book-list' },
    { id: 'nav_about', label: 'About', href: '/about' },
    { id: 'nav_arc', label: 'ARC Requests', href: '/arc-requests' },
    { id: 'nav_recommendations', label: 'Recommendations', href: '/book-recommendations' },
    { id: 'nav_reviews', label: 'Reviews', href: '/book-reviews' },
  ];

  return (
    <nav
      className={`fixed w-full z-50 top-0 transition-all duration-300 ${
        isScrolled
          ? 'bg-background/80 backdrop-blur-xl border-b border-border' :'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/dashboard" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
            <Icon name="BookOpenIcon" size={24} className="text-primary" />
          </div>
          <div className="flex flex-col">
            <span className="font-serif text-lg font-semibold text-foreground tracking-tight">
              BookReview Hub
            </span>
            <span className="text-[10px] text-muted-foreground uppercase tracking-widest">
              Literary Reviews
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks?.map((link) => (
            <Link
              key={link?.id}
              href={link?.href}
              className={`text-sm font-medium tracking-wide transition-colors ${
                pathname === link?.href
                  ? 'text-primary' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              {link?.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden p-2 text-foreground hover:text-primary transition-colors"
          aria-label="Toggle menu"
        >
          <Icon
            name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
            size={24}
          />
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden absolute top-20 left-0 right-0 bg-card/95 backdrop-blur-xl border-b border-border animate-slide-in-right">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {navLinks?.map((link) => (
              <Link
                key={link?.id}
                href={link?.href}
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium tracking-wide py-2 transition-colors ${
                  pathname === link?.href
                    ? 'text-primary' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}